import { handleActions } from 'redux-actions'

// ↓ usage of 'exports' field in package.json is available in webpack v5, so use /lib
// eslint-disable-next-line import/no-unresolved
import { CurrentUserRecord, currentUserFromServer, ExportRecord } from '@albacross/frontend-utils/lib/models/records'

import { CLEAR_EXPORT, EXPORT, FETCH_CURRENT_USER } from 'constants/app-constants'

// Plain state object; user/exportData stay as shared frontend-utils records (read by property, e.g. app.user.id).
const initialState = {
  user: CurrentUserRecord(),
  exportData: ExportRecord(),
}

export default handleActions(
  {
    [`${FETCH_CURRENT_USER}_SUCCESS`]: (s, a) => {
      if (!a.payload.body) return initialState
      const user = a.payload.body.current_user

      const currentUser = currentUserFromServer(user).set('customerUserId', a.payload.body.current_customer?.id)
      return { ...s, user: currentUser }
    },

    [EXPORT]: (s, a) => ({
      ...s,
      exportData: ExportRecord({
        url: a.payload.url,
        fileName: a.payload.fileName,
        data: a.payload.data,
        method: a.payload.method,
        target: a.payload.target,
      }),
    }),

    [CLEAR_EXPORT]: s => ({ ...s, exportData: ExportRecord() }),
  },
  initialState,
)
